import Image from "@components/Image";
import cx from "classnames";
import styles from "./VisitOurRooms.module.scss";

interface Props {
  data: {
    image: {
      src: string;
      alt: string;
    };
    image2: {
      src: string;
      alt: string;
    };
  };
  className: string | { [key: string]: string };
}

export default function Item({ data, className }: Props) {
  return (
    <div className={cx("slide-item animated", className)}>
      <div className={cx(styles.imagesWrapper)}>
        <div className={cx(styles.image1Wrapper)}>
          <Image
            scale={1.1}
            wrapperProps={{ className: cx(styles.image1) }}
            src={data.image.src}
            alt={data.image.alt}
            sizes="60vw"
            layout="fill"
            objectFit="cover"
          />
        </div>
        <div className={cx(styles.image2Wrapper)}>
          <Image
            scale={1.1}
            wrapperProps={{ className: cx(styles.image2) }}
            src={data.image2.src}
            alt={data.image2.alt}
            sizes="60vw"
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </div>
  );
}
